interface ShouldShowBrowseFreeVideosArgs {
  isFreeWeek: boolean;
  isTrial: boolean;
  freeVideos: Array<unknown> | null | undefined;
}

export const shouldShowBrowseFreeVideos = ({ isFreeWeek, isTrial, freeVideos }: ShouldShowBrowseFreeVideosArgs) => {
  if (isFreeWeek) return false;
  if (!isTrial) return false;

  return !!freeVideos?.length;
};
